module.exports = __webpack_public_path__ + "static/img/Bachelor_010285.aadb723.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010285.jpg
// module id = 138
// module chunks = 0